var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"justify-content-center",attrs:{"id":_vm.id}},[_c('div',{staticClass:"administration-section"},[_c('i',{class:`fa fa-${_vm.icon} pr-3 pt-1`}),_vm._v(_vm._s(_vm.title))]),_c('b-row',{staticClass:"administration-section-content mt-4"},[_c('b-col',{attrs:{"cols":"12","md":"9"}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }